module.exports = __webpack_public_path__ + "static/media/Acta-monitoreo.b4d97393.jpeg";